import { GlyphRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasGlyphPicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasGlyphPicker } from "./glyph-picker";

let loadGlyphPick = !1;

export function bindGlyphCanvasPickerContribution(container) {
    loadGlyphPick || (loadGlyphPick = !0, container.bind(CanvasGlyphPicker).toDynamicValue((() => new DefaultCanvasGlyphPicker(resolveContainerBinding(container, GlyphRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasGlyphPicker));
}
//# sourceMappingURL=glyph-module.js.map
